export default "__VITE_ASSET__f2591396__"